<template>
    <button class="containerBtn" type="button" v-on:click="onClick" :class="className" :aria-label="title">
        <img :src="imgUrl" class="icon" alt="" aria-hidden="true" />
        <span class="title" aria-hidden="true">
            {{ title }}
        </span>
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        imgUrl: { type: String, required: true },
        title: { type: String, required: true },
        onClick: { type: Function, required: false },
        className: { type: String, required: false },
    },
});
</script>

<style scoped>
.containerBtn {
    background-color: var(--white);
    width: fit-content;
    display: flex;
    align-items: center;
    border: 1px solid var(--color-principal);
    border-radius: 6px;
    padding: 3px 16px 3px 8px;
    font-weight: var(--font-weight-bold);
    cursor: pointer;
    color: var(--color-principal);
    white-space: nowrap;
}
.container.disabled {
    background-color: var(--background-color-disabled);
    cursor: default;
}
.icon {
    height: 24px;
    width: 24px;
    margin: 0;
    margin-right: 8px;
}
.title {
    text-transform: uppercase;
    font-size: var(--font-size-small);
}
.back-btn span {
    color: var(--white);
}
.back-btn .icon > svg > path {
    fill: var(--white);
}
.back-btn {
    display: flex;
    position: absolute;
    background-color: var(--color-principal);
    right: 24px;
}
.back-btn span {
    color: var(--white);
}
.back-btn .icon > svg > path {
    fill: var(--white);
}
.header-button {
    background-color: white;
    border: 1px solid var(--bleu-secondaire);
    color: white;
}

</style>
